<template>
    <div>
        <div style="margin-bottom: 5px;">
            <el-input v-model="name" placeholder="请输入姓名" suffix-icon="el-icon-search" style="width: 180px;"
                      @keyup.enter.native="loadPost"></el-input>
            <el-select v-model="roleFilter" filterable placeholder="角色筛选" style="margin-left: 5px; width: 140px;" :disabled="isAdmin">
                <el-option v-for="item in roleFilters" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 5px;" @click="loadPost">查询</el-button>
            <el-button type="success" @click="resetParam">重置</el-button>
            <el-button type="primary" style="margin-left: 5px;" @click="add">新增人员</el-button>
        </div>
        <el-table :data="tableData"
                  :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                  border
        >
            <el-table-column prop="id" label="ID" width="60"></el-table-column>
            <el-table-column label="头像" width="70" align="center">
                <template slot-scope="scope">
                    <el-avatar :size="36" :src="scope.row.avatar || null"
                               style="background: linear-gradient(135deg,#ff9ec3,#f0619c); color:#fff; font-weight:700;">
                        {{ (scope.row.name || '星').slice(0, 1) }}
                    </el-avatar>
                </template>
            </el-table-column>
            <el-table-column prop="no" label="账号" width="160"></el-table-column>
            <el-table-column prop="name" label="姓名" width="130"></el-table-column>
            <el-table-column prop="age" label="年龄" width="60"></el-table-column>
            <el-table-column prop="sex" label="性别" width="60">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.sex === 1 ? 'primary' : 'success'" disable-transitions>
                        {{scope.row.sex === 1 ? '男' : '女'}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="roleId" label="角色" width="110">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.roleId === 0 ? 'danger' : (scope.row.roleId === 1 ? 'warning' : 'success')"
                            disable-transitions>
                        {{scope.row.roleId === 0 ? '超级管理员' : (scope.row.roleId === 1 ? '管理员' : '普通用户')}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="phone" label="电话" width="140"></el-table-column>
            <el-table-column prop="coin" label="星裙币" width="90"></el-table-column>
            <el-table-column prop="isvalid" label="状态" width="80">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.isvalid === 'Y' ? 'success' : 'info'" disable-transitions>
                        {{scope.row.isvalid === 'Y' ? '启用' : '禁用'}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="operate" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="small" type="success" @click="mod(scope.row)">编辑</el-button>
                    <el-popconfirm
                            title="确定删除吗？"
                            @confirm="del(scope.row)"
                            style="margin-left: 5px;">
                        <el-button slot="reference" size="small" type="danger">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>

        <el-dialog
                :title="form.id ? '编辑人员' : '新增人员'"
                :visible.sync="centerDialogVisible"
                width="35%"
                center>
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
                <el-form-item label="头像" v-if="form.id">
                    <el-avatar :size="56" :src="form.avatar || null"
                               style="background: linear-gradient(135deg,#ff9ec3,#f0619c); color:#fff; font-weight:700;">
                        {{ (form.name || '星').slice(0, 1) }}
                    </el-avatar>
                </el-form-item>
                <el-form-item label="账号" prop="no">
                    <el-col :span="20">
                        <el-input v-model="form.no"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-col :span="20">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-col :span="20">
                        <el-input v-model="form.password" show-password
                                  :placeholder="form.id ? '留空表示不修改密码' : '请输入密码'"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="年龄" prop="age">
                    <el-col :span="20">
                        <el-input v-model="form.age"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="性别">
                    <el-radio-group v-model="form.sex">
                        <el-radio label="1">男</el-radio>
                        <el-radio label="0">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                    <el-col :span="20">
                        <el-input v-model="form.phone"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="角色" prop="roleId">
                    <el-col :span="20">
                        <el-select v-model="form.roleId" :disabled="isAdmin" style="width: 100%;">
                            <el-option v-if="!isAdmin" label="超级管理员" value="0"></el-option>
                            <el-option label="管理员" value="1"></el-option>
                            <el-option label="普通用户" value="2"></el-option>
                        </el-select>
                        <div v-if="isAdmin" style="color: #999; font-size: 12px; line-height: 1.6;">管理员只能新增/维护普通用户，无法管理其他角色</div>
                    </el-col>
                </el-form-item>
                <el-form-item label="星裙币">
                    <el-col :span="20">
                        <el-input v-model="form.coin" placeholder="新增时留空按角色自动发放"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="状态" v-if="form.id">
                    <el-col :span="20">
                        <el-select v-model="form.isvalid" style="width: 100%;">
                            <el-option label="启用" value="Y"></el-option>
                            <el-option label="禁用" value="N"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "PersonManage",
        data() {
            let checkDuplicate = (rule, value, callback) => {
                if (this.form.id) {
                    return callback();
                }
                this.$axios.get(this.$httpUrl + "/user/findByNo?no=" + this.form.no).then(res => res.data).then(res => {
                    if (res.code != 200) {
                        callback()
                    } else {
                        callback(new Error('账号已经存在'));
                    }
                }).catch(() => callback(new Error('账号校验失败，请稍后重试')))
            };
            return {
                user: JSON.parse(sessionStorage.getItem('CurUser') || '{}'),
                tableData: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                name: '',
                roleFilter: '',
                roleFilters: [
                    {value: '', label: '全部角色'},
                    {value: '0', label: '超级管理员'},
                    {value: '1', label: '管理员'},
                    {value: '2', label: '普通用户'}
                ],
                centerDialogVisible: false,
                form: {
                    id: '',
                    no: '',
                    name: '',
                    password: '',
                    age: '',
                    sex: '0',
                    phone: '',
                    roleId: '2',
                    coin: '',
                    isvalid: 'Y',
                    avatar: ''
                },
                rules: {
                    no: [
                        {required: true, message: '请输入账号', trigger: 'blur'},
                        {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'},
                        {validator: checkDuplicate, trigger: 'blur'}
                    ],
                    name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                    password: [
                        {
                            validator: (rule, value, callback) => {
                                if (!this.form.id && !value) {
                                    callback(new Error('请输入密码'));
                                } else if (value && (value.length < 3 || value.length > 8)) {
                                    callback(new Error('长度在 3 到 8 个字符'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
                    ],
                    age: [
                        {required: true, message: '请输入年龄', trigger: 'blur'},
                        {pattern: /^([1-9][0-9]*){1,3}$/, message: '年龄必须为正整数字', trigger: "blur"}
                    ],
                    phone: [
                        {required: true, message: "手机号不能为空", trigger: "blur"},
                        {pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码", trigger: "blur"}
                    ]
                }
            }
        },
        computed: {
            // 当前登录人是否为管理员（只能操作普通用户）
            isAdmin() {
                return Number(this.user.roleId) === 1
            }
        },
        methods: {
            resetForm() {
                this.$refs.form && this.$refs.form.resetFields();
            },
            del(row) {
                this.$axios.get(this.$httpUrl + '/user/del', {
                    params: {
                        id: row.id,
                        operatorRole: this.user.roleId,
                        operatorNo: this.user.no,
                        operatorName: this.user.name
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功！', type: 'success'});
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                }).catch(() => this.$message.error('网络异常，请稍后重试'))
            },
            mod(row) {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.form.id = row.id
                    this.form.no = row.no
                    this.form.name = row.name
                    this.form.password = ''
                    this.form.age = row.age == null ? '' : row.age + ''
                    this.form.sex = (row.sex === 1 || row.sex === '1') ? '1' : '0'
                    this.form.phone = row.phone
                    this.form.roleId = row.roleId + ''
                    this.form.coin = row.coin == null ? '' : row.coin + ''
                    this.form.isvalid = row.isvalid || 'Y'
                    this.form.avatar = row.avatar || ''
                })
            },
            add() {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.resetForm()
                    this.form.id = ''
                    this.form.roleId = '2'
                    this.form.coin = ''
                    this.form.isvalid = 'Y'
                })
            },
            doSave() {
                let body = Object.assign({}, this.form, {
                    operatorRole: this.user.roleId,
                    operatorNo: this.user.no,
                    operatorName: this.user.name
                });
                this.$axios.post(this.$httpUrl + '/user/save', body).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功！', type: 'success'});
                        this.centerDialogVisible = false
                        this.loadPost()
                        this.resetForm()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                }).catch(() => this.$message.error('网络异常，请稍后重试'))
            },
            doMod() {
                let body = Object.assign({}, this.form, {
                    operatorRole: this.user.roleId,
                    operatorNo: this.user.no,
                    operatorName: this.user.name
                });
                this.$axios.post(this.$httpUrl + '/user/update', body).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功！', type: 'success'});
                        this.centerDialogVisible = false
                        this.loadPost()
                        this.resetForm()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                }).catch(() => this.$message.error('网络异常，请稍后重试'))
            },
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if (this.form.id) {
                            this.doMod();
                        } else {
                            this.doSave();
                        }
                    } else {
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageNum = 1
                this.pageSize = val
                this.loadPost()
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.loadPost()
            },
            resetParam() {
                this.name = ''
                this.roleFilter = ''
            },
            loadPost() {
                this.$axios.post(this.$httpUrl + '/user/listPageC1', {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {
                        name: this.name,
                        roleId: this.roleFilter + '',
                        operatorRole: this.user.roleId + ''
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data
                        this.total = res.total
                    } else {
                        alert('获取数据失败')
                    }
                }).catch(() => this.$message.error('网络异常，请稍后重试'))
            }
        },
        beforeMount() {
            this.loadPost()
        }
    }
</script>

<style scoped>

</style>
